/*
 *@description: 公告
 *@file: 
 *@author: qiuhongyang
 *@date: 2020-06-29 17:21:20
 *
*/
import web_config from "../../config/web";
import txt from "../txt";

class Gonggao{
    Options:any;
    constructor(opt:any){
        let defaultopt = {
            boxid:"",
            size:5,
            market: "",
            stockcode: "",
            showtime:true,   //是否展示时间标签
            titlelength:38   //title截取长度
        };
        this.Options = $.extend({}, defaultopt, opt);

        this.renderHtml();
    };

    async getData(){
        let _this = this;
        let par = _this.Options;
        let stockcode = (par.stockcode).replace(".","_");
        let backdata = await $.ajax({
            url: `${web_config.getUrl('new_notice_api')}api/security/ann?cb=?`,
            type: 'GET',
            dataType: 'jsonp',
            data: {
                page_size: par.size,
                page_index:1,
                market_code: par.market,
                stock_list: stockcode,
                client_source:'web'
            }
        })
        return backdata;
    };

    async renderHtml(){
        let _this = this;
        let $html:any = "";
        let back:any = await _this.getData();
    
        if (back && back.data && back.data.list && back.data.list.length > 0) {
           
        }else{
            $html = '<span class="nodatalist">暂无数据</span>';
            $(_this.Options.boxid).append($html)
            return false;
        };

        let backstr: Array<string> = ['<ul>'];

        back.data.list.forEach((v: any, index: number) => {
            try {
                let stock_code = v.codes[0].stock_code;
                let art_code = v.art_code;
                let timespan = "";
                if (_this.Options.showtime) {
                    timespan = `<span>${v.notice_date.substring(5, 10)}</span>`;
                }
                let tlen = _this.Options.titlelength;
                let zwurl = "http://data.eastmoney.com/notices/detail/" + stock_code + "/" + art_code + ".html";

                backstr.push(`<li>${timespan}<a target="_blank" title="${v.title}" href="${zwurl}">${txt.txtLeft(v.title, tlen, false)}</a></li>`);
            } catch (error) {
                
            }
        });

        backstr.push('</ul>');

        $html = $(backstr.join(''));

        $(_this.Options.boxid).append($html)
    };


}; 


export default Gonggao;